import { ITEMIZATION_WIDGET_ACTION } from './itemizationWidgetActions';
import { MONTHLY_SUMMARY_DATA_RESET } from './monthlySummaryActions';
import { INSIGHTS_BILL_USAGE_ACTIONS } from './insightsBillUsageActions';
import { RECOMMENDATIONS_ACTIONS } from './recommendationsActions';

export const resetData = () => {
  let actions = [
    {type: ITEMIZATION_WIDGET_ACTION.RESET_DATA},
    {type: MONTHLY_SUMMARY_DATA_RESET},
    {type: INSIGHTS_BILL_USAGE_ACTIONS.RESET_DATA},
    {type: RECOMMENDATIONS_ACTIONS.RESET_DATA}
  ];

  return dispatch => {
    actions.forEach(action => {
      dispatch(action)
    });
  }
};